import { APPLE, AUTH0, GOOGLE, SLACK, WINDOWS } from './oAuthKeys';

export { APPLE, AUTH0, GOOGLE, SLACK, WINDOWS };
export const USERNAME = 'username';
export const NONE = 'none';

// sort order used for smart login priortization
// if a user has more than one associated auth flows
// the lower value will be given preference
export const AUTH_TYPES_SORT_ORDER = new Map([
  [USERNAME, 0],
  [GOOGLE, 1],
  [SLACK, 2],
  [APPLE, 3],
  [WINDOWS, 4],
]);
